module.exports = __webpack_public_path__ + "img/labelsOrderOff.3ce0dba1.svg";